const { PRODUCTION_ORIGIN } = require('./seo');

const FALLBACK_SOCIAL_IMAGE = {
  url: `${PRODUCTION_ORIGIN}/social/digifist-premier-v1.jpg`,
  type: 'image/jpeg',
  width: 1200,
  height: 630,
  alt: 'DigiFist — Shopify Premier Agency. Design. Build. Scale.',
};

const RASTER_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif']);
const EXTENSION_TYPES = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp', gif: 'image/gif' };

/** Keep editorial artwork; provide a static, crawler-readable image when absent. */
function socialImage(media, alt = '') {
  const attributes = media?.data?.attributes;
  if (!attributes || typeof attributes.url !== 'string' || !attributes.url.trim()) return FALLBACK_SOCIAL_IMAGE;
  const source = attributes.url.trim();
  if (!source.startsWith('/uploads/') && !source.startsWith('https://')) return FALLBACK_SOCIAL_IMAGE;
  let url;
  try {
    // CMS upload URLs are relative to the media host, never the preview host.
    url = new URL(source, 'https://cmsad.digifist.com');
  } catch {
    return FALLBACK_SOCIAL_IMAGE;
  }
  if (url.protocol !== 'https:' || url.username || url.password || url.port) return FALLBACK_SOCIAL_IMAGE;
  const extension = url.pathname.split('.').pop()?.toLowerCase();
  const type = attributes.mime || EXTENSION_TYPES[extension];
  if (!RASTER_TYPES.has(type) || (extension === 'svg') || attributes.size > 5000) return FALLBACK_SOCIAL_IMAGE;
  const width = Number.isInteger(attributes.width) && attributes.width > 0 ? attributes.width : undefined;
  const height = Number.isInteger(attributes.height) && attributes.height > 0 ? attributes.height : undefined;
  // Each SEO instance supplies a complete image descriptor. Omitting dimensions
  // would let an earlier Layout Head tag survive Next's keyed deduplication.
  if (!width || !height || width < 200 || height < 200) return FALLBACK_SOCIAL_IMAGE;
  const imageAlt = typeof attributes.alternativeText === 'string' ? attributes.alternativeText.trim() : '';
  return { url: url.toString(), type, width, height, alt: imageAlt || alt || 'DigiFist' };
}

function openGraphType(value) {
  return ['website', 'article', 'profile', 'book'].includes(value) || /^(?:music|video)\.[a-z_]+$/.test(value || '') ? value : 'website';
}

module.exports = { FALLBACK_SOCIAL_IMAGE, socialImage, openGraphType };
